import { render, staticRenderFns } from "./Landings.vue?vue&type=template&id=1196fe88&scoped=true"
import script from "./Landings.vue?vue&type=script&lang=js"
export * from "./Landings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196fe88",
  null
  
)

export default component.exports